import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldAlert, Copy, CheckCircle2, ExternalLink, AlertCircle } from "lucide-react";

const wrap = "ti-dark -m-3 -mb-24 min-h-[calc(100vh-3rem)] px-4 py-4 sm:-m-5 sm:px-6 lg:-mb-5 lg:px-8 lg:py-5";

export default function OwnerBootstrap() {
  const [status, setStatus] = useState(null);
  const [link, setLink] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  const loadStatus = () => api.get("/root/status").then((r) => setStatus(r.data)).catch(() => setStatus(null));
  useEffect(() => { loadStatus(); }, []);

  const generate = async () => {
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/root/bootstrap", {});
      setLink(data.setup_url);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const copy = () => { navigator.clipboard.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 2000); };

  return (
    <div className={wrap} data-testid="owner-bootstrap-page">
      <div className="mx-auto max-w-2xl">
        <div className="flex items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-500/12 text-amber-300 ring-1 ring-inset ring-amber-400/30" style={{ boxShadow: "0 0 14px rgba(245,158,11,0.35)" }}><ShieldAlert size={20} /></span>
          <div><h1 className="font-heading text-lg font-extrabold tracking-tight text-white sm:text-xl">Bootstrap ROOT OWNER</h1><p className="text-[11px] text-[#AAB8CC]">Buat secure one-time setup link untuk akun break-glass</p></div>
        </div>

        {error && <div className="mt-4 flex items-start gap-2 rounded-lg border border-rose-400/30 bg-rose-500/10 px-3 py-2.5 text-sm text-rose-300"><AlertCircle size={16} className="mt-0.5 shrink-0" /><span>{error}</span></div>}

        <div className="ti-dcard mt-4 p-5">
          {status?.activated ? (
            <div className="flex items-center gap-2 text-emerald-300"><CheckCircle2 size={18} /><span className="text-sm font-semibold">ROOT OWNER sudah aktif ({status.email}). Kelola di Owner Security Center.</span></div>
          ) : (
            <>
              <p className="text-sm text-slate-300">Akun ROOT OWNER: <span className="font-mono text-blue-200">{status?.email || "—"}</span></p>
              <p className="mt-1 text-xs text-slate-400">Link berlaku 30 menit, sekali pakai. Buka link untuk menetapkan password (12+) dan MFA.</p>
              {!link ? (
                <Button data-testid="bootstrap-generate-btn" onClick={generate} disabled={loading} className="mt-4 h-11 bg-blue-600 font-semibold text-white hover:bg-blue-500">{loading ? "Membuat…" : "Generate Secure Setup Link"}</Button>
              ) : (
                <div className="mt-4 space-y-3">
                  <div className="rounded-lg border border-white/10 bg-black/20 p-3 font-mono text-xs text-blue-200 break-all" data-testid="bootstrap-link">{link}</div>
                  <div className="flex gap-2">
                    <Button data-testid="bootstrap-copy-btn" onClick={copy} variant="outline" className="h-10 border-white/15 bg-white/5 text-white hover:bg-white/10">{copied ? <><CheckCircle2 size={15} className="mr-1.5" />Tersalin</> : <><Copy size={15} className="mr-1.5" />Salin link</>}</Button>
                    <a href={link} target="_blank" rel="noreferrer" className="flex h-10 items-center gap-1.5 rounded-md bg-blue-600 px-4 text-sm font-semibold text-white hover:bg-blue-500"><ExternalLink size={15} /> Buka link</a>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
